import { Box } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';

import { useGridTheme } from '@/hooks/useGridTheme';
import type { AssetConnectionMetricsDTO } from '@/pages/Assets';

import useStyles from './AssetConnectivityTable.styles';
import ASSET_CONNECTIVITY_COLUMNS from './AssetConnectivityTable.utils';

const AssetConnectivityTable = ({
  selectedAssetConnections,
  title
}: {
  selectedAssetConnections: AssetConnectionMetricsDTO[];
  title?: string;
}) => {
  const gridTheme = useGridTheme();
  const { classes } = useStyles();

  return (
    <div className={classes.assetConnectivityTableWrapper}>
      {title && (
        <Box className={classes.assetConnectivityTableHeader}>{title}</Box>
      )}
      <AgGridReact
        rowData={selectedAssetConnections?.slice(0, 10) || []}
        columnDefs={ASSET_CONNECTIVITY_COLUMNS}
        theme={gridTheme}
        rowHeight={45}
      />
    </div>
  );
};

export default AssetConnectivityTable;
